import React, { useState } from 'react';
import { User, Sparkles, MapPin, Bell, ChevronRight, Camera, Check, Plus, X, Clock } from 'lucide-react';
export function SettingsPage() {
  const [activeSection, setActiveSection] = useState('profilo');
  // State for Services
  const [activeServices, setActiveServices] = useState<string[]>(['Pulizia Standard', 'Pulizia Profonda', 'Check-out Express', 'Sanificazione']);
  const allServices = ['Pulizia Standard', 'Pulizia Profonda', 'Check-out Express', 'Sanificazione', 'Lavanderia', 'Giardinaggio'];
  // State for Zones
  const [activeZones, setActiveZones] = useState<string[]>(['Prati', 'Centro Storico', 'Trastevere']);
  // State for Notifications
  const [notifications, setNotifications] = useState({
    opportunities: true,
    updates: true,
    weekly: false
  });
  const toggleService = (service: string) => {
    if (activeServices.includes(service)) {
      setActiveServices(activeServices.filter(s => s !== service));
    } else {
      setActiveServices([...activeServices, service]);
    }
  };
  const removeZone = (zone: string) => {
    setActiveZones(activeZones.filter(z => z !== zone));
  };
  const toggleNotification = (key: keyof typeof notifications) => {
    setNotifications(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  const scrollToSection = (id: string) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      // Offset for sticky header
      const yOffset = -100;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-2166">
      {/* Header */}
      <header data-id="element-2167">
        <h1 className="text-xl lg:text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-2168">
          Impostazioni
        </h1>
        <p className="text-sm text-gray-500" data-id="element-2169">
          Gestisci il tuo profilo e le preferenze del servizio
        </p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2170">
        {/* Sidebar Navigation */}
        <div className="lg:col-span-1 space-y-4" data-id="element-2171">
          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden sticky top-24" data-id="element-2172">
            <nav className="p-2 space-y-1" data-id="element-2173">
              <button onClick={() => scrollToSection('profilo')} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${activeSection === 'profilo' ? 'bg-teal-50 text-teal-deep font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}`} data-id="element-2174">
                <User size={18} data-id="element-2175" />
                Profilo
                {activeSection === 'profilo' && <ChevronRight size={16} className="ml-auto" data-id="element-2176" />}
              </button>

              <button onClick={() => scrollToSection('servizi')} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${activeSection === 'servizi' ? 'bg-teal-50 text-teal-deep font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}`} data-id="element-2177">
                <Sparkles size={18} data-id="element-2178" />
                Servizi Offerti
                {activeSection === 'servizi' && <ChevronRight size={16} className="ml-auto" data-id="element-2179" />}
              </button>

              <button onClick={() => scrollToSection('zone')} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${activeSection === 'zone' ? 'bg-teal-50 text-teal-deep font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}`} data-id="element-2180">
                <MapPin size={18} data-id="element-2181" />
                Zone e Spostamenti
                {activeSection === 'zone' && <ChevronRight size={16} className="ml-auto" data-id="element-2182" />}
              </button>

              <button onClick={() => scrollToSection('notifiche')} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${activeSection === 'notifiche' ? 'bg-teal-50 text-teal-deep font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}`} data-id="element-2183">
                <Bell size={18} data-id="element-2184" />
                Notifiche
                {activeSection === 'notifiche' && <ChevronRight size={16} className="ml-auto" data-id="element-2185" />}
              </button>
            </nav>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="lg:col-span-2 space-y-6" data-id="element-2186">
          {/* Card 1: Profilo Personale */}
          <div id="profilo" className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-2187">
            <h2 className="text-lg font-bold text-navy mb-6" data-id="element-2188">
              Profilo Personale
            </h2>

            {/* Avatar Section */}
            <div className="flex items-center gap-4 mb-8" data-id="element-2189">
              <div className="relative group cursor-pointer" data-id="element-2190">
                <div className="w-20 h-20 rounded-full bg-teal-100 border-2 border-teal-200 flex items-center justify-center text-teal-deep text-xl font-bold" data-id="element-2191">
                  SB
                </div>
                <div className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2192">
                  <Camera className="text-white w-6 h-6" data-id="element-2193" />
                </div>
              </div>
              <div data-id="element-2194">
                <button className="text-sm font-medium text-teal-deep hover:text-teal-700 transition-colors mb-1" data-id="element-2195">
                  Cambia foto
                </button>
                <p className="text-xs text-gray-500" data-id="element-2196">
                  JPG, GIF o PNG. Max 1MB.
                </p>
              </div>
            </div>

            {/* Form Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2197">
              <div className="space-y-1.5" data-id="element-2198">
                <label className="text-sm font-medium text-gray-700" data-id="element-2199">
                  Nome
                </label>
                <input type="text" defaultValue="Sofia" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-2200" />
              </div>
              <div className="space-y-1.5" data-id="element-2201">
                <label className="text-sm font-medium text-gray-700" data-id="element-2202">
                  Cognome
                </label>
                <input type="text" defaultValue="Bianchi" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-2203" />
              </div>
              <div className="space-y-1.5 md:col-span-2" data-id="element-2204">
                <label className="text-sm font-medium text-gray-700" data-id="element-2205">
                  Email
                </label>
                <input type="email" defaultValue="sofia.bianchi@email.com" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-2206" />
              </div>
              <div className="space-y-1.5" data-id="element-2207">
                <label className="text-sm font-medium text-gray-700" data-id="element-2208">
                  Telefono
                </label>
                <input type="tel" defaultValue="+39 333 456 7890" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-2209" />
              </div>
              <div className="space-y-1.5" data-id="element-2210">
                <label className="text-sm font-medium text-gray-700" data-id="element-2211">
                  Partita IVA
                </label>
                <input type="text" defaultValue="IT12345678901" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-2212" />
              </div>
              <div className="space-y-1.5 md:col-span-2" data-id="element-2213">
                <label className="text-sm font-medium text-gray-700" data-id="element-2214">
                  Ruolo
                </label>
                <input type="text" defaultValue="Fornitore" disabled className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-500 cursor-not-allowed" data-id="element-2215" />
              </div>
            </div>

            <div className="mt-8 flex justify-end" data-id="element-2216">
              <button className="bg-teal-deep text-white px-6 py-2.5 rounded-lg font-medium text-sm hover:bg-teal-deep/90 transition-colors shadow-sm" data-id="element-2217">
                Salva Modifiche
              </button>
            </div>
          </div>

          {/* Card 2: Servizi Offerti */}
          <div id="servizi" className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-2218">
            <div className="flex items-center gap-2 mb-1" data-id="element-2219">
              <Sparkles size={18} className="text-teal-deep" data-id="element-2220" />
              <h2 className="text-lg font-bold text-navy" data-id="element-2221">I tuoi servizi</h2>
            </div>
            <p className="text-sm text-gray-500 mb-4" data-id="element-2222">
              Seleziona i servizi che offri ai tuoi clienti
            </p>

            <div className="flex flex-wrap gap-2.5" data-id="element-2223">
              {allServices.map(service => {
              const isActive = activeServices.includes(service);
              return <button key={service} onClick={() => toggleService(service)} className={`flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-all ${isActive ? 'bg-teal-50 text-teal-deep border border-teal-200' : 'bg-white text-gray-500 border border-dashed border-gray-300 hover:border-gray-400 hover:text-gray-700'}`} data-id="element-2224">
                    {isActive && <Check size={14} data-id="element-2225" />}
                    {service}
                  </button>;
            })}
            </div>
          </div>

          {/* Card 3: Zone Operative */}
          <div id="zone" className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-2226">
            <div className="flex items-center gap-2 mb-4" data-id="element-2227">
              <MapPin size={18} className="text-teal-deep" data-id="element-2228" />
              <h2 className="text-lg font-bold text-navy" data-id="element-2229">Zone preferite</h2>
            </div>

            <div className="flex flex-wrap gap-2 mb-4" data-id="element-2230">
              {activeZones.map(zone => <span key={zone} className="bg-teal-50 text-teal-deep border border-teal-200 rounded-full px-3 py-1.5 text-sm font-medium flex items-center gap-1.5" data-id="element-2231">
                  {zone}
                  <button onClick={() => removeZone(zone)} className="hover:bg-teal-100 rounded-full p-0.5 transition-colors" data-id="element-2232">
                    <X size={14} data-id="element-2233" />
                  </button>
                </span>)}
              <button className="border border-dashed border-gray-300 rounded-full px-3 py-1.5 text-sm text-gray-500 hover:border-teal-deep hover:text-teal-deep flex items-center gap-1.5 transition-colors" data-id="element-2234">
                <Plus size={14} data-id="element-2235" />
                Aggiungi zona
              </button>
            </div>

            <div className="border-t border-gray-100 my-5" data-id="element-2236"></div>

            <div className="space-y-3" data-id="element-2237">
              <div className="flex justify-between items-center" data-id="element-2238">
                <label className="text-sm font-medium text-navy" data-id="element-2239">
                  Raggio massimo spostamento
                </label>
                <span className="text-lg font-bold text-teal-deep" data-id="element-2240">8 km</span>
              </div>
              <div className="relative w-full h-2 bg-gray-100 rounded-full" data-id="element-2241">
                <div className="absolute left-0 top-0 h-full bg-teal-deep rounded-full" style={{
                width: '40%'
              }} data-id="element-2242"></div>
                <div className="absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-2 border-teal-deep rounded-full shadow-sm cursor-pointer hover:scale-110 transition-transform" style={{
                left: '40%'
              }} data-id="element-2243"></div>
              </div>
            </div>

            <div className="border-t border-gray-100 my-5" data-id="element-2244"></div>

            <div className="space-y-1" data-id="element-2245">
              <label className="text-sm font-medium text-navy" data-id="element-2246">
                Orari preferiti
              </label>
              <div className="flex items-baseline gap-2" data-id="element-2247">
                <span className="text-base font-semibold text-navy" data-id="element-2248">
                  08:00 - 18:00
                </span>
                <span className="text-xs text-gray-400" data-id="element-2249">Lun - Ven</span>
              </div>
            </div>
          </div>

          {/* Card 4: Notifiche */}
          <div id="notifiche" className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-2250">
            <h2 className="text-lg font-bold text-navy mb-4" data-id="element-2251">
              Preferenze Notifiche
            </h2>

            <div className="space-y-4" data-id="element-2252">
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2253">
                <div data-id="element-2254">
                  <p className="text-sm font-medium text-navy" data-id="element-2255">
                    Nuove Opportunità
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2256">
                    Ricevi una notifica quando ci sono nuovi lavori nella tua
                    zona
                  </p>
                </div>
                <button onClick={() => toggleNotification('opportunities')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${notifications.opportunities ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-2257">
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${notifications.opportunities ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2258" />
                </button>
              </div>

              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2259">
                <div data-id="element-2260">
                  <p className="text-sm font-medium text-navy" data-id="element-2261">
                    Aggiornamenti Lavori
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2262">
                    Notifiche sullo stato dei lavori assegnati
                  </p>
                </div>
                <button onClick={() => toggleNotification('updates')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${notifications.updates ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-2263">
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${notifications.updates ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2264" />
                </button>
              </div>

              <div className="flex items-center justify-between py-3" data-id="element-2265">
                <div data-id="element-2266">
                  <p className="text-sm font-medium text-navy" data-id="element-2267">
                    Riepilogo Settimanale
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2268">
                    Ricevi un report via email ogni lunedì mattina
                  </p>
                </div>
                <button onClick={() => toggleNotification('weekly')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${notifications.weekly ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-2269">
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${notifications.weekly ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2270" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}